import { IEventRequestParams, IImageWithObjectKey, IImageWithUrl } from './shared.dto';
import { MagicLinkValidityPeriodStrategy } from './website.dao';

abstract class IPassportSettingsConfigurationDAO {
    public abstract getPassportSettingsConfiguration(params: IEventRequestParams): Promise<IPassportSettingsConfigurationDTO>;
    public abstract updatePassportSettingsConfiguration(
        params: IEventRequestParams,
        passportConfigurationConfiguration: IPassportSettingsConfigurationDTO
    ): Promise<IPassportSettingsConfigurationDTO>;
    public abstract getPassportTitleConfiguration(params: IEventRequestParams): Promise<IEventTitleAndDescription>;
    public abstract editPassportTitleConfiguration(
        params: IEventRequestParams,
        data: IEventTitleAndDescription
    ): Promise<IEventTitleAndDescription>;
}
interface IPassportSettingsConfigurationDTO {
    subdomain: string;
    themeId: number;
    eventTitleForPassport: string;
    eventPublicDescription: string;
    eventPrivateDescription: string;
    privacyPolicyLabel: string;
    signInLandingWith: string;
    predefinedAccessCode: string;
    requestAccessCodeAutoSingInEnabled: boolean;
    privacyPolicyEnabled: boolean;
    magicLinkBuildStrategy: MagicLinkValidityPeriodStrategy;
    magicLinkValidityDays?: number;
    primaryColor: string;
    logoImage?: IImageWithObjectKey;
    logoImageWithUrl?: IImageWithUrl;
    logoAltText: string;
    backgroundImage?: IImageWithObjectKey;
    backgroundImageWithUrl?: IImageWithUrl;
    backgroundAltText: string;
    showCookieNotification: boolean;
    cookieNotificationText: string;
    websiteLogoImage?: IImageWithObjectKey;
    websiteLogoImageWithUrl?: IImageWithUrl;
    websiteLogoAltText: string;
    showWebsiteLogoImage?: boolean;
    websiteFooterLogoImage?: IImageWithObjectKey;
    websiteFooterLogoImageWithUrl?: IImageWithUrl;
    showWebsiteFooterLogoImage?: boolean;
    thumbnailImage?: IImageWithObjectKey;
    thumbnailImageWithUrl?: IImageWithUrl;
    timeZoneDisplayType: string;
    customTimeZoneDisplay: string;
    showEventTimeZone: boolean;
    calendarInvite: string;
    calendarButtonOnMeetingDetailsPageEnabled: boolean;
    attendeeSsoEnabled: boolean;
}

interface IEventTitleAndDescription extends Pick <
    IPassportSettingsConfigurationDTO,
    'eventTitleForPassport' |
    'eventPublicDescription' |
    'eventPrivateDescription' |
    'thumbnailImage' |
    'thumbnailImageWithUrl'
> {};

export {
    IPassportSettingsConfigurationDAO,
    IPassportSettingsConfigurationDTO,
    IEventTitleAndDescription,
};
